import * as plotLineActions from '../../actions/plotLinesActions';
import * as chartActionTypes from '../../constants/chart-action-types';
import * as utils from './plotLines.utils';

const initialState = {
  plotLines: [utils.getInitialView()],
  mustRender: false,
};

function plotLinesReducer(state = initialState, action) {
  const { value, id, stateTree, color } = action;

  switch (action.type) {
    case chartActionTypes.DESTROY_CHART:
      return initialState;
    case plotLineActions.MUST_RENDER_FALSE:
      return { ...state, mustRender: value };
    case chartActionTypes.RECEIVE_CHART:
      return utils.fetchPlotLineInfo(state, action);
    case plotLineActions.ADD_VIEW:
      return utils.updateView(state, color);
    case plotLineActions.REMOVE_PLOTLINE:
      return utils.deletePlotLine(stateTree, state, id, color);
    case plotLineActions.UPDATE_PLOT_LINE_VALUE:
      return utils.updateChart(stateTree, state, value, id, 'plotLineValue');
    case plotLineActions.UPDATE_PLOT_LINE_DASH_STYLE:
      return utils.updateChart(stateTree, state, value, id, 'plotLineDashStyle');
    case plotLineActions.UPDATE_PLOT_LINE_LABEL:
      return utils.updateChart(stateTree, state, value, id, 'plotLineLabel');
    case plotLineActions.UPDATE_PLOT_LINE_LABEL_POSITION:
      return utils.updateChart(stateTree, state, value, id, 'plotLineLabelPosition');
    case plotLineActions.UPDATE_PLOT_LINE_COLOR:
      return utils.updateChart(stateTree, state, value, id, 'plotLineColor');
    default:
      return state;
  }
}

export default plotLinesReducer;
